import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { StorefrontBreadcrumbs } from '../../navigation/components/StorefrontBreadcrumbs';
import { StorefrontBreadcrumbStructuredData } from '../../navigation/components/StorefrontBreadcrumbsStructuredData';
import { SearchBar } from '../../search-bar/components/SearchBar';
import { ManageBuildDropdowns } from './ManageBuildDropdowns';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function BaseHeader({
  dataTestId = 'base-header',
  backBreadcrumb,
  pathKey,
  productType,
  title,
  subtitle
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(StorefrontBreadcrumbStructuredData, {
      backBreadcrumb: backBreadcrumb,
      pathKey: pathKey,
      productType: productType,
      title: title
    }), /*#__PURE__*/_jsxs(Flex, {
      alignItems: "end",
      columnGap: "1000",
      "data-test-id": dataTestId,
      flexWrap: "wrap",
      justifyContent: "space-between",
      paddingBlock: "1100",
      position: "relative",
      rowGap: "500",
      children: [/*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        flexShrink: 0,
        gap: "600",
        marginBlockEnd: "100",
        maxInlineSize: "600px",
        children: [/*#__PURE__*/_jsx(StorefrontBreadcrumbs, {
          backBreadcrumb: backBreadcrumb,
          pathKey: pathKey,
          productType: productType,
          title: title
        }), /*#__PURE__*/_jsxs(View, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h1",
            typography: "heading-600",
            children: title
          }), subtitle && /*#__PURE__*/_jsx(View, {
            marginBlockStart: "200",
            maxInlineSize: "100%",
            children: /*#__PURE__*/_jsx(Text, {
              children: subtitle
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(ManageBuildDropdowns, {}), /*#__PURE__*/_jsx(View, {
        alignSelf: "end",
        flexGrow: 1,
        maxInlineSize: "600px",
        minInlineSize: "400px",
        children: /*#__PURE__*/_jsx(SearchBar, {})
      })]
    })]
  });
}